import { DateTime } from 'luxon';
import axios from 'smg/axios';
import { Start, Stop } from 'smg/buttons';
import { Child, Extra, NewQuoteRequest } from 'smg/customer-api/quoterequests';
import { Session } from 'smg/customer-api/session';
import { HandleRequestError } from 'smg/errors';
import { ReportValidity } from 'smg/form';
import { Phone } from 'smg/phone';
import { Uploader } from 'smg/uploads';
import { GetFirstAndLast } from 'smg/users';
import { Relref } from '../hugo';

declare interface myWindow extends Window {
    dataLayer: Record<string, unknown>[];
}
declare const window: myWindow;
declare interface getPromoResponse {
    promotionalCode: {
        promotionalCodeID: string;
        name: string;
        description: string;
        code: string;
        sameOwner: boolean;
    };
}

export default function main() {
    const form = document.querySelector('#form') as HTMLFormElement;

    const radios = document.querySelectorAll<HTMLInputElement>('input[type="radio"]');
    radios.forEach(radio => radio.addEventListener('click', () => {
        const step = radio.closest('.step') as HTMLElement;
        let nextStep: HTMLElement;

        if (radio.name === 'sport') {
            if (radio.value === 'Baseball') {
                nextStep = step.parentElement?.querySelector('.baseball') as HTMLElement;
                step.parentElement?.querySelector('.softball')?.classList.add('d-none');
                step.parentElement?.querySelector('.softball-plating')?.classList.add('d-none');
            } else {
                nextStep = step.parentElement?.querySelector('.softball') as HTMLElement;
                step.parentElement?.querySelector('.baseball')?.classList.add('d-none');
                step.parentElement?.querySelector('.baseball-plating')?.classList.add('d-none');
            }

            step.parentElement?.querySelector('.final')?.classList.add('d-none');
        } else if (radio.name === 'plating') {
            nextStep = step.parentElement?.querySelector('.step.final') as HTMLElement;
        } else {
            nextStep = step.nextElementSibling as HTMLElement;
        }

        if (nextStep) {
            nextStep.classList.remove('d-none');
            nextStep.scrollIntoView({
                behavior: 'smooth',
            });
        }
    }));

    const fieldset = form.querySelector('fieldset') as HTMLFieldSetElement;
    const submit = form.querySelector('[type="submit"]') as HTMLButtonElement;

    const quantity = form.querySelector('#quantity') as HTMLInputElement;
    const dateEl = form.querySelector('#date') as HTMLInputElement;
    const budget = form.querySelector('#budget') as HTMLInputElement;
    const team = form.querySelector('#team') as HTMLInputElement;
    const colors = form.querySelector('#colors') as HTMLInputElement;
    const notes = form.querySelector('#notes') as HTMLTextAreaElement;
    const promo = form.querySelector('#promo') as HTMLInputElement;

    const fullName = form.querySelector('#full-name') as HTMLInputElement;
    const email = form.querySelector('#email') as HTMLInputElement;
    const phone = form.querySelector('#phone') as HTMLInputElement;

    const u = new Uploader(document.querySelector('#uploads') as HTMLLabelElement, {
        confirmBtn: submit || undefined,
    });

    const p = new Phone(phone);

    form.noValidate = true;
    form.addEventListener('submit', async e => {
        e.preventDefault();

        const startLoading = () => {
            fieldset.disabled = true;
            Start(submit);
        };
        const stopLoading = () => {
            fieldset.disabled = false;
            Stop(submit);
        };

        startLoading();

        promo.setCustomValidity('');
        if (promo.value) {
            promo.setCustomValidity('The promo code is not valid.');
            await axios.get<getPromoResponse>(`/promos/${encodeURIComponent(promo.value)}`).
                then(resp => {
                    if (resp.data.promotionalCode.promotionalCodeID) {
                        promo.setCustomValidity('');
                    }
                }).catch(err => console.error(err));
        }

        dateEl.setCustomValidity('');
        const date = DateTime.fromJSDate(new Date(dateEl.value));
        if (date < DateTime.local()) {
            dateEl.setCustomValidity('The date must be in the future.');
        }

        stopLoading();
        if (!ReportValidity(form)) {
            return false;
        }
        startLoading();

        const sport = document.querySelector('[name="sport"]:checked') as HTMLInputElement;
        const template = document.querySelector('[name="template"]:checked') as HTMLInputElement;
        const plating = document.querySelector('[name="plating"]:checked') as HTMLInputElement;

        const extras: Extra[] = [];

        extras.push({
            name: 'Sport',
            value: sport.value,
        });

        if (colors) {
            if (colors.value) {
                extras.push({
                    name: 'Colors',
                    value: colors.value,
                });
            }
        }

        if (team?.value) {
            extras.push({
                name: 'Team',
                value: team.value,
            });
        }

        const children: Child[] = [];

        children.push({
            child: 'plating',
            option: plating.value,
        });

        void NewQuoteRequest({
            company: team?.value || '',
            email: email?.value || '',
            name: fullName?.value || '',
            phone: p,

            budget: parseFloat(budget?.value) || 0,
            dateNeeded: date.toISODate() ?? undefined,
            lineItem: 'lapel pins',
            type: 'Made in USA - Rush Pins',
            size: template.value,
            extras,
            children,

            uploader: u,
            project: `${new Date().getFullYear()} ${team ? team.value : ''}`,
            notes: notes?.value || '',
            promo: promo.value,
            quantity: parseInt(quantity?.value, 10) || 0,
        }).then(async quoteRequest => {
            const sess = await Session().catch(() => undefined);
            const dataLayer = window.dataLayer || [];
            const { firstName, lastName } = GetFirstAndLast(String(fullName.value));
            dataLayer.push({
                'event': 'hugo-new-trading-pin-quote-request',
                'userData': {
                    'email': sess?.email || email.value,
                    'phone': sess?.phone || await p.Format(),
                    'firstName': sess?.firstName || firstName,
                    'lastName': sess?.lastName || lastName,
                },
                'transactionId': quoteRequest.id,
                // 'products': gtmProducts,
                'total': quoteRequest.quotes?.[0].cachedTotal,
            });

            window.location.href = Relref('/quote/received');
        }).catch(err => {
            stopLoading();

            HandleRequestError(err, form);
        });
    });
}